import { useTranslation } from "react-i18next";
import type { EnumPaymentType } from "@/api/cashier";

/* The TransactionHistoryTypeLabel component is used to get user-friendly labels for transaction types
  @param type - The transaction type (EnumPaymentType)
  @returns The user-friendly label for the transaction type
*/
export const TransactionHistoryTypeLabel = ({
  type,
  isDetailsTitle,
}: {
  type: EnumPaymentType;
  isDetailsTitle?: boolean;
}) => {
  const { t } = useTranslation();

  /* Map transaction types to user-friendly labels */
  const transactionTypeMap: Record<EnumPaymentType, string> = {
    deposit: t("transactions.history.table.types.deposit"),
    withdrawal: t("transactions.history.table.types.withdrawal"),
    transfer: t("transactions.history.table.types.transfer"),
    cashAdjustment: t("transactions.history.table.types.cash_adjustment"),
  };

  const transactionDetailTypeMap: Record<EnumPaymentType, string> = {
    deposit: t("transactions.history.details.deposit"),
    withdrawal: t("transactions.history.details.withdrawal"),
    transfer: t("transactions.history.details.transfer"),
    cashAdjustment: t("transactions.history.details.cash_adjustment"),
  };

  return isDetailsTitle ? (
    <span>{transactionDetailTypeMap[type] ?? type}</span>
  ) : (
    <span>{transactionTypeMap[type] ?? type}</span>
  );
};
